import { jsx as e, jsxs as i, Fragment as w } from "react/jsx-runtime";
import { useRef as _, useState as d, useEffect as z } from "react";
import { Verified as W } from "../Verified/index.js";
import { C as E } from "../../CircularLoader-zywd2AbP.js";
import { n as S } from "../../emotion-styled.browser.esm-Br5Hs_hj.js";
import '../../assets/index13.css';function V() {
  return /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        // backgroundColor: "red",
        borderRadius: "50%",
        // width: 80,
        // height: 80,
        padding: 20,
        marginLeft: -4
      },
      children: /* @__PURE__ */ e(
        "svg",
        {
          style: {
            transform: "translateX(3px)"
            // fill: "rgba(255, 255, 255, 0.8)",
            // fillOpacity: 0.4,
          },
          xmlns: "http://www.w3.org/2000/svg",
          width: "50px",
          height: "50px",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: "0 0 16 16",
          children: /* @__PURE__ */ e(
            "path",
            {
              fill: "rgba(255, 255, 255, 1)",
              d: "m11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
            }
          )
        }
      )
    }
  );
}
function R({
  id: p,
  token: l,
  videoPlaybackId: c,
  thumbFrame: m = 2,
  reviewSource: h,
  // videoThumbnail,
  name: f,
  stars: y
}) {
  const r = _(null), [a, I] = d(!1), [L, g] = d(!1), [s, v] = d(!1), [A, b] = d("PLAYING"), u = `https://image.mux.com/${c}/thumbnail.png?fit_mode=preserve&time=${m}&height=400`, x = `https://image.mux.com/${c}/animated.gif?fit_mode=preserve&start=${m}&end=${m + 3}&height=400`, P = x && L ? x : u, [C] = l.split("_");
  z(() => {
    const n = r.current;
    if (n) {
      const o = () => {
        v(!0);
      };
      return n.addEventListener("canplay", o), () => {
        n.removeEventListener("canplay", o);
      };
    }
  }, [v, a]);
  const j = l + "_" + p;
  return /* @__PURE__ */ i(w, { children: [
    /* @__PURE__ */ i(
      "div",
      {
        style: {
          ...t.wrapper,
          opacity: a && s ? 0 : 1
        },
        role: "button",
        onClick: () => I(!0),
        onMouseEnter: () => g(!0),
        onMouseLeave: () => g(!1),
        children: [
          /* @__PURE__ */ e(
            "img",
            {
              src: P,
              alt: "video thumbnail",
              style: t.thumbnail,
              loading: "lazy"
            }
          ),
          /* @__PURE__ */ e("div", { style: t.playWrapper, children: a && !s ? /* @__PURE__ */ e(E, {}) : /* @__PURE__ */ e(V, {}) }),
          /* @__PURE__ */ i("div", { style: t.reviewerInfoWrapper, children: [
            /* @__PURE__ */ i("h4", { style: t.name, children: [
              f,
              /* @__PURE__ */ e("span", { style: t.verifiedWrapper, children: /* @__PURE__ */ e(W, { source: h }) })
            ] }),
            y
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      $,
      {
        onClick: () => {
          var n, o;
          A === "PLAYING" ? ((n = r == null ? void 0 : r.current) == null || n.pause(), b("PAUSED")) : ((o = r == null ? void 0 : r.current) == null || o.play(), b("PLAYING"));
        },
        style: {
          cursor: "pointer",
          position: "absolute",
          top: 0,
          display: a && s ? "block" : "none",
          zIndex: a && s ? 2 : -1,
          width: "100%"
        },
        children: a && /* @__PURE__ */ i(w, { children: [
          /* @__PURE__ */ e(
            "mux-player",
            {
              id: j,
              placeholder: u,
              autoplay: !0,
              ref: r,
              style: t.videoPlayer,
              class: "mux-player",
              "stream-type": "on-demand",
              "playback-id": c,
              "metadata-video-id": l + "_" + p,
              "metadata-video-title": l + "_" + p,
              "metadata-viewer-user-id": C,
              controls: "false",
              loop: !0
            }
          ),
          /* @__PURE__ */ i("div", { style: t.reviewerInfoWrapper, children: [
            /* @__PURE__ */ i("h4", { style: t.name, children: [
              f,
              /* @__PURE__ */ e("span", { style: t.verifiedWrapper, children: /* @__PURE__ */ e(W, { source: h }) })
            ] }),
            y
          ] })
        ] })
      }
    )
  ] });
}
const $ = S.div`
    mux-player {
        --media-object-fit: cover;
        --media-background-color: transparent;
        border-radius: 8px;
    }
    video {
        border-radius: 8px;
    }
`, t = {
  wrapper: {
    position: "relative",
    zIndex: 2,
    cursor: "pointer"
  },
  thumbnail: {
    cursor: "pointer",
    borderRadius: 8,
    height: 400,
    minWidth: 250,
    width: "100%",
    objectFit: "cover",
    // width: "100%",
    verticalAlign: "middle"
  },
  playWrapper: {
    position: "absolute",
    display: "flex",
    bottom: 0,
    justifyContent: "center",
    width: "100%",
    // minWidth: 300,
    alignItems: "center",
    height: "100%",
    cursor: "pointer",
    borderRadius: 8,
    background: "linear-gradient(0deg, rgba(0,0,0,0.5004595588235294) 0%, rgba(255,255,255,0) 24%)"
  },
  name: {
    margin: 0,
    fontFamily: "inherit",
    fontSize: 18,
    fontWeight: 700,
    color: "#fff"
    // display: "flex",
    // alignItems: "center",
  },
  reviewerInfoWrapper: {
    position: "absolute",
    left: 24,
    bottom: 24,
    right: 24,
    textAlign: "left"
  },
  verifiedWrapper: {
    marginLeft: 4,
    height: 22,
    display: "inline-block",
    verticalAlign: "middle"
  },
  videoPlayer: {
    // width: 250,
    // @ts-ignore
    "border-radius": 8,
    "--media-object-fit": "cover",
    "--media-background-color": "transparent",
    /* Hide the error dialog */
    "--controls": "none"
  }
};
export {
  R as Video
};
